const options = {
  startDates: [
    {
      value: '2021-09-30',
      label: 'In the next two weeks',
    },
    {
      value: '2021-10-15',
      label: 'In the next month',
    },
    {
      value: '2021-11-01',
      label: 'In the next couple months',
    },
  ],
  durations: [
    {
      value: 1,
      label: '2-4 weeks',
    },
    {
      value: 2,
      label: '4-6 weeks',
    },
    {
      value: 3,
      label: '6-8 weeks',
    },
    {
      value: 4,
      label: '2-3 months',
    },
    {
      value: 5,
      label: '3-4 months',
    },
    {
      value: 6,
      label: '5-6 months',
    },
    {
      value: 7,
      label: 'Ongoing',
    },
  ],
  budgets: [
    {
      value: 1000.0,
      label: '$0-1,000',
    },
    {
      value: 2500.0,
      label: '$1,000-2,500',
    },
    {
      value: 5000.0,
      label: '$2,500-5,000',
    },
    {
      value: 10000.0,
      label: '$5,000-10,000',
    },
    {
      value: 20000.0,
      label: '$10,000-20,000',
    },
    {
      value: 30000.0,
      label: '$20,000-30,000',
    },
    {
      value: 50000.0,
      label: '$30,000-50,000',
    },
    {
      value: 100000.0,
      label: '$50,000-100,000',
    },
    {
      value: 1000000.0,
      label: '$100,000+',
    },
  ],
};

export default options;
